<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <v-card class='elevation-2 animated fadeIn'>
                    <v-toolbar flat>
                        <v-toolbar-title>Diplomas</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-stepper v-model="currentStep">
                            <v-stepper-header>
                                <v-stepper-step :complete="currentStep > 1" step="1">Región</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="currentStep > 2" step="2">Distrito</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="currentStep > 3" step="3">Escuela</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="currentStep > 4" step="4">Estudiantes</v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" v-on:click="getAllRegions"><v-icon>refresh</v-icon> Refrescar</v-btn>
                                    </v-layout>
                                    <v-text-field v-model="searchRegions"
                                                  append-icon="search"
                                                  label="Buscar"
                                                  single-line
                                                  hide-details></v-text-field>
                                    <v-data-table :headers="regionsHeaders"
                                                  :items="regions"
                                                  :search="searchRegions"
                                                  :loading="regionsLoading"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                                  class="elevation-1">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td>{{ props.item.REGION_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.DIPLOMAS }}</td>
                                            <td class="text-xs-center"><v-btn color="success" small fab v-on:click="selectRegion(props)"><v-icon>done_outline</v-icon></v-btn></td>
                                            <td><v-btn color="warning" fab small v-on:click="downloadReportDiplomasPorRegion(props)"><v-icon>cloud_download</v-icon></v-btn></td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Su búsqueda por "{{ searchRegions }}" no encontro resultados.
                                        </v-alert>
                                    </v-data-table>
                                </v-stepper-content>
                                <v-stepper-content step="2">
                                    <v-layout row>
                                        <v-btn color="primary" v-on:click.native="currentStep = 1"><v-icon>arrow_back</v-icon> Atrás</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" v-on:click="getAllDistrictsByRegion"><v-icon>refresh</v-icon> Refrescar</v-btn>
                                    </v-layout>
                                    <v-alert dark :value="true" color="success" icon="new_releases">
                                        <p><strong>Región</strong> {{ selectedRegion.REGION_NAME }}</p>
                                    </v-alert>
                                    <v-text-field v-model="searchDistricts"
                                                  append-icon="search"
                                                  label="Buscar"
                                                  single-line
                                                  hide-details></v-text-field>
                                    <v-data-table :headers="districtsHeaders"
                                                  :items="districts"
                                                  :search="searchDistricts"
                                                  :loading="districtsLoading"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                                  class="elevation-1">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td>{{ props.item.DISTRICT_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.DIPLOMAS }}</td>
                                            <td class="text-xs-center"><v-btn color="success" small fab v-on:click="selectDistrict(props)"><v-icon>done_outline</v-icon></v-btn></td>
                                            <td><v-btn color="warning" fab small v-on:click="downloadReportDiplomasPorDistricto(props)"><v-icon>cloud_download</v-icon></v-btn></td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Su búsqueda por "{{ searchDistricts }}" no encontro resultados.
                                        </v-alert>
                                    </v-data-table>
                                </v-stepper-content>
                                <v-stepper-content step="3">
                                    <v-layout row>
                                        <v-btn color="primary" v-on:click.native="currentStep = 2"><v-icon>arrow_back</v-icon> Atrás</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" v-on:click="getAllSchoolsByDistrict"><v-icon>refresh</v-icon> Refrescar</v-btn>
                                    </v-layout>
                                    <v-alert dark :value="true" color="success" icon="new_releases">
                                        <p><strong>Región</strong> {{ selectedRegion.REGION_NAME }}</p>
                                        <p><strong>Distrito</strong> {{ selectedDistrict.DISTRICT_NAME }}</p>
                                    </v-alert>
                                    <v-text-field v-model="searchSchools"
                                                  append-icon="search"
                                                  label="Buscar"
                                                  single-line
                                                  hide-details></v-text-field>
                                    <v-data-table :headers="schoolsHeaders"
                                                  :items="schools"
                                                  :search="searchSchools"
                                                  :loading="schoolsLoading"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                                  class="elevation-1">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td>{{ props.item.SCHOOL_NAME }}</td>
                                            <td>{{ props.item.SCHOOL_CODE }}</td>
                                            <td>{{ props.item.MUNICIPALITY }}</td>
                                            <td class="text-xs-left">{{ props.item.DIPLOMAS }}</td>
                                            <td class="text-xs-center"><v-btn color="success" small fab v-on:click="selectSchool(props)"><v-icon>done_outline</v-icon></v-btn></td>
                                            <td><v-btn color="warning" fab small v-on:click="downloadReportDiplomasPorEscuela(props)"><v-icon>cloud_download</v-icon></v-btn></td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Su búsqueda por "{{ searchSchools }}" no encontro resultados.
                                        </v-alert>
                                    </v-data-table>
                                </v-stepper-content>
                                <v-stepper-content step="4">
                                    <v-layout row>
                                        <v-btn color="primary" v-on:click.native="currentStep = 3"><v-icon>arrow_back</v-icon> Atrás</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" v-on:click="getAllStudentsBySchool"><v-icon>refresh</v-icon> Refrescar</v-btn>
                                    </v-layout>
                                    <v-alert dark :value="true" color="success" icon="new_releases">
                                        <p><strong>Región</strong> {{ selectedRegion.REGION_NAME }}</p>
                                        <p><strong>Distrito</strong> {{ selectedDistrict.DISTRICT_NAME }}</p>
                                        <p><strong>Escuela</strong> {{ selectedSchool.SCHOOL_CODE }} - {{ selectedSchool.SCHOOL_NAME }}</p>
                                    </v-alert>
                                    <v-text-field v-model="searchStudents"
                                                  append-icon="search"
                                                  label="Buscar"
                                                  single-line
                                                  hide-details></v-text-field>
                                    <v-data-table :headers="studentsHeaders"
                                                  :items="students"
                                                  :search="searchStudents"
                                                  :loading="studentsLoading"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                                  class="elevation-1">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.item.STUDENT_ID }}</td>
                                            <td class="text-xs-left">{{ props.item.FULL_LAST_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.FIRST_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.MIDDLE_NAME }}</td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Su búsqueda por "{{ searchStudents }}" no encontro resultados.
                                        </v-alert>
                                    </v-data-table>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import script from './script'
    export default script
</script>


// WEBPACK FOOTER //
// src/components/diplomas/index/component.vue